import { CALL_API } from 'middleware/api';
import { includeCreditReportParam } from 'utils/creditReportAccounts';
export const getPotBalanceHistory = (from, to, spaceId) => ({
    [CALL_API]: {
        endpoint: `/wealth/spaces/${spaceId}/pots/balance-history?from=${from}&to=${to}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            'GET_POT_BALANCE_HISTORY_REQUEST',
            'GET_POT_BALANCE_HISTORY_SUCCESS',
            'GET_POT_BALANCE_HISTORY_FAILURE',
        ],
        extra: { from, to },
    },
});
export const getPortfolioBalanceHistory = (from, to, spaceId) => ({
    [CALL_API]: {
        endpoint: `/wealth/spaces/${spaceId}/trading/balance-history?from=${from}&to=${to}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            'GET_PORTFOLIO_BALANCE_HISTORY_REQUEST',
            'GET_PORTFOLIO_BALANCE_HISTORY_SUCCESS',
            'GET_PORTFOLIO_BALANCE_HISTORY_FAILURE',
        ],
        extra: { from, to },
    },
});
export const getALLBalanceHistory = (graphSection, graphType) => ({
    [CALL_API]: {
        endpoint: `/balance-history?graphSection=${graphSection}&range=MAX&graphType=${graphType}${includeCreditReportParam('&')}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            'GET_ALL_BALANCE_HISTORY_REQUEST',
            'GET_ALL_BALANCE_HISTORY_SUCCESS',
            'GET_ALL_BALANCE_HISTORY_FAILURE',
        ],
        extra: {
            graphSection,
            graphType,
        },
    },
});
